<template>
  <div class="user-filter-show-new flex-box">
    <div class="user-filter-relation" v-if="chooseIndex > 0">
      <el-form :model="chooseFilters[chooseIndex]" :rules="rules" :ref="id" label-width="0px" class="demo-ruleForm">
        <el-form-item label="" prop="relation">
          <el-select @change="changeRelation" v-model="chooseFilters[chooseIndex]['relation']" placeholder="请选择" style="width:90px;" size="small" :disabled="disabled">
            <el-option
              v-for="item in relationOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="showbox boxsizing m-10 p-15 err" v-if="JSON.stringify(chooseFilters[chooseIndex]['filter']) === '{}'">
      <div class="alignC nofilters">
        <el-link icon="el-icon-edit" :underline="false" class="m-r-10" @click="editFilter">编辑</el-link>
        <el-link icon="el-icon-delete" :underline="false" v-show="chooseFilters.length > 1" @click="deleteFilter">删除</el-link>
      </div>
    </div>
    <div class="showbox boxsizing m-10 p-15" v-else>
      <div class="toolbar auto alignR" v-if="!disabled">
        <el-link icon="el-icon-edit" :underline="false" class="m-r-10" @click="editFilter">编辑</el-link>
        <el-link icon="el-icon-delete" :underline="false" v-show="chooseFilters.length > 1" @click="deleteFilter">删除</el-link>
      </div>
      <div v-for="(item, index) in newChooseFilters['filter']" :key="index" v-if="!checkEmpty(item)" class="box-column-box m-tb-10 p-10">
        <div class="box-title auto">
          <div class="fl">{{filters[index].name}}</div>
          <div v-if="item.child_time && item.child_time.length" class="alignR font14 fr">
            {{item.child_time[0] + ' 至 ' + item.child_time[1]}}
          </div>
        </div>
        <div v-for="(item2, index2) in item['filter']" :key="index2" v-if="item2 && item2.length" class="box-column-box-item">
          <div class="filterscroll auto" v-if="filters[index] && filters[index]['filter'] && filters[index]['filter'][index2] && filters[index]['filter'][index2]['html_type'] && (filters[index]['filter'][index2]['html_type'] === 'li' || filters[index]['filter'][index2]['html_type'] === 'li_search')">
            <div class="filtersitem auto">
              <div class="filterstitle auto boxsizing ellipsis">{{filters[index]['filter'][index2]['name']}}：</div>
              <div class="filterscon auto">
                <div class="filtersconbox auto">
                  <div class="filtersconboxul boxsizing">
                    <ul>
                      <li v-for="(item3, index3) in item2" :key="index3">{{filters[index]['filter'][index2]['list'][item3]}}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="filterscroll auto" v-if="filters[index] && filters[index]['filter'] && filters[index]['filter'][index2] && filters[index]['filter'][index2]['html_type'] && filters[index]['filter'][index2]['html_type'] === 'input'">
            <div class="filtersitem auto">
              <div class="filterstitle auto boxsizing ellipsis">{{filters[index]['filter'][index2]['name']}}：</div>
              <div class="filterscon auto">
                <div class="filtersconbox auto">
                  <div class="filtersconboxul boxsizing">
                    <ul>
                      <li>{{item2}}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="filterscroll auto" v-if="filters[index] && filters[index]['filter'] && filters[index]['filter'][index2] && filters[index]['filter'][index2]['html_type'] && filters[index]['filter'][index2]['html_type'] === 'datetime'">
            <div class="filtersitem auto">
              <div class="filterstitle auto boxsizing ellipsis">{{filters[index]['filter'][index2]['name']}}：</div>
              <div class="filterscon auto">
                <div class="filtersconbox auto">
                  <div class="filtersconboxul boxsizing">
                    <ul>
                      <li>{{item2[0] + ' 至 ' + item2[1]}}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="filters[index] && filters[index]['filter'] && filters[index]['filter'][index2] && filters[index]['filter'][index2]['html_type'] && filters[index]['filter'][index2]['html_type'] === 'multi_select'">
            <div class="filterscroll auto" v-for="(item3, index3) in filters[index]['filter'][index2]['list']" :key="index3">
              <div class="filtersitem auto">
                <div class="filterstitle auto boxsizing ellipsis">{{item3['group_name']}}：</div>
                <div class="filterscon auto">
                  <div class="filtersconbox auto">
                    <div class="filtersconboxul boxsizing">
                      <ul>
                        <li v-for="(item4, index4) in item3['child']" :key="index4" v-if="item2.indexOf(item4['event_id']) > -1">{{item4['event_name']}}</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Mp } from '@/model'
export default {
  name: 'userFilterShow',
  props: [
    'filters',
    'chooseFilters',
    'chooseIndex',
    'disabled'
  ],
  data () {
    return {
      relation: '',
      newChooseFilters: {},
      relationOptions: [],
      rules: {
        relation: [
          {required: true, message: '请选择计算方式', trigger: 'change'}
        ]
      }
    }
  },
  computed: {
    id () {
      return 'ruleForm-' + this.util.uuid()
    }
  },
  watch: {
    'chooseFilters': function (val) {
      this.newChooseFilters = JSON.parse(JSON.stringify(val[this.chooseIndex]))
      this.initChoose()
      if (this.$refs[this.id]) {
        this.$refs[this.id].validate((valid) => {})
      }
    },
    'chooseIndex': function (val) {
      this.newChooseFilters = JSON.parse(JSON.stringify(this.chooseFilters[val]))
      this.initChoose()
    }
  },
  methods: {
    checkEmpty (obj) {
      let isEmpty = true
      for (let key in obj['filter']) {
        let item = obj['filter'][key]
        if (item && item.length) {
          isEmpty = false
        }
      }
      return isEmpty
    },
    initChoose () {
      // if (this.disabled) {
        // this.newChooseFilters = JSON.parse(JSON.stringify(this.newChooseFilters))
        // this.initChooseTurn(this.filters)
      // } else {
      this.newChooseFilters = JSON.parse(JSON.stringify(this.newChooseFilters))
      // }
    },
    // initChooseTurn (filter) {
    //   console.log('this.newChooseFilters', this.newChooseFilters)
    //   console.log('filter', filter)
    //   var dataStr = {}
    //   for (let key in filter) {
    //     if (this.newChooseFilters['filter'][key]) {
    //       dataStr[key] = {}
    //       dataStr[key]['name'] = filter[key]['name']
    //       if (filter[key]['child_time']) {
    //         dataStr[key]['child_time'] = this.newChooseFilters['filter'][key]['child_time'] || ''
    //       }
    //       dataStr[key]['name'] = filter[key]['name']
    //       dataStr[key]['filter'] = {}
    //       for (let k in filter[key]['filter']) {
    //         if (this.newChooseFilters['filter'][key]['filter'][k]) {
    //           if (filter[key]['filter'][k]['html_type'] === 'input') {
    //             dataStr[key]['filter'][k] = {
    //               name: filter[key]['filter'][k]['name'],
    //               value: this.newChooseFilters['filter'][key]['filter'][k]
    //             }
    //           } else if (filter[key]['filter'][k]['html_type'] === 'datetime') {
    //             dataStr[key]['filter'][k] = {
    //               name: filter[key]['filter'][k]['name'],
    //               value: this.newChooseFilters['filter'][key]['filter'][k]
    //             }
    //           } else {
    //             let obj = []
    //             this.newChooseFilters['filter'][key]['filter'][k].map((item, index) => {
    //               obj.push({
    //                 name: filter[key]['filter'][k]['list'][item],
    //                 value: item
    //               })
    //             })
    //             dataStr[key]['filter'][k] = {
    //               name: filter[key]['filter'][k]['name'],
    //               value: obj
    //             }
    //           }
    //           dataStr[key]['filter'][k]['html_type'] = filter[key]['filter'][k]['html_type']
    //         }
    //       }
    //     }
    //   }
    //   let newChooseFilters = {
    //     relation: this.newChooseFilters['relation'],
    //     filter: dataStr
    //   }
    //   this.newChooseFilters = JSON.parse(JSON.stringify(newChooseFilters))
    //   console.log('dataStr', this.newChooseFilters)
    // },
    async getPackageRelationSetting () {
      let res = await Mp.Custom.getPackageRelationSetting()
      if (!res['err_code']) {
        let options = []
        for (let key in res['data']) {
          options.push({
            id: key,
            name: res['data'][key]
          })
        }
        this.relationOptions = options
      }
    },
    editFilter () {
      this.$emit('editFilter', this.chooseIndex)
    },
    deleteFilter () {
      this.$emit('deleteFilter', this.chooseIndex)
    },
    changeRelation (val) {
      console.log('this.newChooseFilters',this.newChooseFilters)
      this.$emit('changeRelation', val, this.chooseIndex)
    }
  },
  created () {
    this.newChooseFilters = JSON.parse(JSON.stringify(this.chooseFilters[this.chooseIndex]))
    this.initChoose()
    this.getPackageRelationSetting()
  },
  mounted () {
    if (this.$refs[this.id]) {
      this.$refs[this.id].validate((valid) => {})
    }
  }
}
</script>

<style scoped>
.user-filter-show-new {
  width: 100%;
}
.showbox {
  width: 100%;
  height: 300px;
  overflow: auto;
  border-radius: 4px;
  box-shadow: 0 0 1px 2px rgba(0,0,0,0.05);
}
.showbox.err {
  box-shadow: 0 0 1px 2px rgba(255,0,0,0.2);
}
.user-filter-relation {
  padding-top: 140px;
}
.toolbar {
  border-bottom: 1px solid #eee;
  line-height: 20px;
  padding-bottom: 10px;
}
.box-title {
  border-bottom: 1px solid #eee;
}
.box-column-box {
  background: rgba(3,3,3,.01);
}
.nofilters {
  padding-top: 110px;
}
.filterscroll {
  line-height: 22px;
}
.box-column-box-item {
  border-bottom: 1px dashed #eee;
  padding: 10px 0;
}
.box-column-box .box-column-box-item:last-child {
  border-bottom: none;
  padding-bottom: 0;
}
.filtersconboxul ul li {
  float: left;
}
.filtersconboxul ul li:after {
  content: '，'
}
.filtersconboxul ul li:last-child:after{
  content: ''
}
</style>
